import { gql } from "@apollo/client";

export const PutConsentMutation = gql`
  mutation PutConsent($consentInput: ConsentInput!) {
    putConsent(consentInput: $consentInput) {
      name
      accepted
      createdAt
      updatedAt
    }
  }
`;
